// 修改透氧系数弹窗
import { InputNumber, Modal, Form, Input } from 'antd';
import { isNaN } from 'lodash';
import React, { Component } from 'react';
class OxygenPermeabilityCoefficient extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  baseFormRef = React.createRef();
  componentDidMount() {
    this.baseFormRef.current.setFieldsValue({
      oxygen_mmhg: this.props.oxygenMmhg,
      ContactOxygen: this.props.contactOxygen,
    })
  }

  toOxygenCountHPa = () => {
    let value = Number(this.baseFormRef.current.getFieldValue("oxygen_mmhg")) || 0
    this.baseFormRef.current.setFieldsValue({
      ContactOxygen: (value / 1.33322).toFixed(2)
    })
  }
  // toOxygenCountMmhg
  toOxygenCountMmhg = () => {
    let value = Number(this.baseFormRef.current.getFieldValue("ContactOxygen")) || 0
    this.baseFormRef.current.setFieldsValue({
      oxygen_mmhg: (value * 1.33322).toFixed(2)
    })
  }

  onOk = () => {
    let mmhg = this.baseFormRef.current.getFieldValue("oxygen_mmhg")
    let hpa = this.baseFormRef.current.getFieldValue("ContactOxygen")
    this.props.onOk({ hpa, mmhg, id: this.props.id })
  }
  render() {
    const { open } = this.props
    return (
      <Modal
        title="透氧系数快捷填写"
        width={700}
        onCancel={this.props.onCancel}
        visible={open}
        onOk={this.onOk}
      >
        <Form
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
          ref={this.baseFormRef}
          style={{ position: "relative" }}
        >
          <Form.Item label="透氧系数(hPa)">
            <Input.Group compact>
              <Form.Item
                name="ContactOxygen"
                noStyle
                rules={[{ required: false }]}
              >
                <InputNumber placeholder='请填写' style={{ width: 200 }} precision={2} />
              </Form.Item>
              <Form.Item
                rules={[{ required: false }]}
              >
                <span className='ml16'>x10^</span>
                <span>-11</span>
                <span className=''>(cm
                  <span>2</span>
                  <span className=''>/s)[mLO
                    <span>2</span>
                    <span className=''>/(mL x hPa)]</span>
                  </span>
                </span>
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => {
              return prevValues.ContactOxygen !== currentValues.ContactOxygen;
            }}
          >
            {({ getFieldValue }) => (
              <Input.Group compact>
                <Form.Item
                  rules={[{ required: false }]}
                  style={{ position: "absolute", top: -50, width: 220, left: 140 }}
                >
                  {
                    (getFieldValue("ContactOxygen") || getFieldValue("ContactOxygen") === 0) && (
                      (Number(getFieldValue("ContactOxygen") || 0)).toFixed(2) + "Dk单位(hPa)"
                    )
                  }
                </Form.Item>
                <Form.Item
                  rules={[{ required: false }]}
                  style={{ position: "absolute", top: -50, width: 200, right: 43 }}
                >
                  <div style={{ width: 3, height: 90, background: "#ccc", marginTop: 13 }}></div>
                  <div style={{ position: "absolute", left: -14, top: -2, width: 0, height: 0, borderLeft: "15px solid transparent", borderRight: "15px solid transparent", borderBottom: "15px solid #ccc" }}></div>
                  <a style={{ position: "absolute", top: 35, left: 10 }} onClick={this.toOxygenCountHPa}>转换</a>
                </Form.Item>
                <Form.Item
                  rules={[{ required: false }]}
                  style={{ position: "absolute", top: -50, width: 200, right: -58 }}
                >
                  <div style={{ width: 3, height: 90, background: "#ccc" }}></div>
                  <div style={{ position: "absolute", left: -14, bottom: -15, width: 0, height: 0, borderLeft: "15px solid transparent", borderRight: "15px solid transparent", borderTop: "15px solid #ccc" }}></div>
                  <a style={{ position: "absolute", top: 35, left: 10 }} onClick={this.toOxygenCountMmhg}>转换</a>
                </Form.Item>
              </Input.Group>
            )}
          </Form.Item>
          <Form.Item label="透氧系数(mmhg)" style={{ marginTop: 50 }}>
            <Input.Group compact>
              <Form.Item
                name="oxygen_mmhg"
                noStyle
                rules={[{ required: false }]}
              >
                <InputNumber placeholder='请填写' style={{ width: 200 }} precision={2} />
              </Form.Item>
              <Form.Item
                rules={[{ required: false }]}
              >
                <span className='ml16'>x10^</span>
                <span>-11</span>
                <span className=''>(cm
                  <span>2</span>
                  <span className=''>/s)[mLO
                    <span>2</span>
                    <span className=''>/(mL x mmHg)]</span>
                  </span>
                </span>
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => {
              return prevValues.oxygen_mmhg !== currentValues.oxygen_mmhg;
            }}
          >
            {({ getFieldValue }) => (
              <Input.Group compact>
                <Form.Item
                  rules={[{ required: false }]}
                  style={{ position: "absolute", top: -50, width: 220, left: 140 }}
                >
                  {
                    (getFieldValue("oxygen_mmhg") || getFieldValue("oxygen_mmhg") === 0) && (
                      Number(getFieldValue("oxygen_mmhg") || 0).toFixed(2) + "Dk单位(mmHg)"
                    )
                  }
                </Form.Item>
              </Input.Group>
            )}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default OxygenPermeabilityCoefficient;


// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addinfomation/components/oxygenPermeabilityCoefficientModal.jsx